import React from 'react';
import PropTypes from 'prop-types';

/* eslint-disable react/no-danger */

const Svg = ({ svg, className }) => (
  <span dangerouslySetInnerHTML={{ __html: svg }} className={className} />
);

Svg.propTypes = {
  svg: PropTypes.string.isRequired,
  className: PropTypes.string
};

Svg.defaultProps = {
  className: ''
};

export default Svg;
